module.exports = require('./helpers/bundle-url').getBundleURL('bCgob') + "logo.c51670a8.svg";